import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title is-size-4 has-text-centered mb-6" }, "Project description", -1)
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Project name "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please indicate project name and/or acronym"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1)
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Project details "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Summary of the project in few lines: main goals, scope, ambition"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1)
const _hoisted_11 = { class: "control is-fullwidth" }
const _hoisted_12 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Partnership / R&D institutions involved "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please indicate R&D institutions/universities/technological centers involved in the consortium"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1)
const _hoisted_15 = { class: "control" }
const _hoisted_16 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  style: {"white-space":"nowrap"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Sector "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select the sector/s of your project results application/s"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1)
const _hoisted_20 = { class: "control" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select ...", -1)
const _hoisted_22 = ["label", "value"]
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  style: {"white-space":"nowrap"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Industry "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light",
    "data-tooltip": "Please select the industry applied"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1)
const _hoisted_25 = { class: "control" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select ...", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Call for funding you are applying "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select the open/forthcoming call for funding"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1)
const _hoisted_32 = { class: "control" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select ...", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered is-size-7" }, "or choose call by identifier", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "or Select ...", -1)
const _hoisted_37 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.prjName) = $event)),
                  type: "text",
                  class: _normalizeClass(["input", { 'is-danger': _ctx.errors.prjName }])
                }, null, 2), [
                  [_vModelText, _ctx.data.prjName]
                ]),
                (_ctx.errors.prjName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "This field is required"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.prjDescr) = $event)),
                  class: _normalizeClass(["textarea is-fullwidth", { 'is-danger': _ctx.errors.prjDescr }])
                }, null, 2), [
                  [_vModelText, _ctx.data.prjDescr]
                ])
              ]),
              (_ctx.errors.prjDescr)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "This field is required"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.partnership) = $event)),
                  type: "text",
                  class: _normalizeClass(["input", { 'is-danger': _ctx.errors.partnership }])
                }, null, 2), [
                  [_vModelText, _ctx.data.partnership]
                ])
              ]),
              (_ctx.errors.partnership)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, " This field is required "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: _normalizeClass(["select is-fullwidth", { 'is-danger': _ctx.errors.secId }])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sector) = $event))
                  }, [
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectors, (sector) => {
                      return (_openBlock(), _createElementBlock("option", {
                        label: sector.name,
                        value: sector.id,
                        key: sector.id
                      }, null, 8, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.sector]
                  ])
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: _normalizeClass(["select is-fullwidth", { 'is-danger': _ctx.errors.secId }])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.secId) = $event))
                  }, [
                    _hoisted_26,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSectors, (sec) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: sec.id,
                        key: sec.id
                      }, _toDisplayString(sec.name), 9, _hoisted_27))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.data.secId]
                  ])
                ], 2),
                (_ctx.errors.secId)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, "This field is required"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", {
                  class: _normalizeClass(["select is-fullwidth", { 'is-danger': _ctx.errors.fndId }])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.fndId) = $event))
                  }, [
                    _hoisted_33,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fundingSorted('name'), (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_34))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.data.fndId]
                  ])
                ], 2),
                _hoisted_35,
                _createElementVNode("div", {
                  class: _normalizeClass(["select is-fullwidth", { 'is-danger': _ctx.errors.fndId }])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.fndId) = $event))
                  }, [
                    _hoisted_36,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fundingSorted('identifier'), (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.identifier), 9, _hoisted_37))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.data.fndId]
                  ])
                ], 2)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}